module.exports = __webpack_public_path__ + "img/success-icon.b0c58f03.svg";